var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 5.48165C16.1975 5.17915 13.1267 5.02332 10.065 5.02332C8.25 5.02332 6.435 5.11498 4.62 5.29832L2.75 5.48165",
    stroke: "#FF2929",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79175 4.55587L7.99341 3.35504C8.14008 2.48421 8.25008 1.83337 9.79925 1.83337H12.2009C13.7501 1.83337 13.8692 2.52087 14.0067 3.36421L14.2084 4.55587",
    stroke: "#FF2929",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2793 8.3783L16.6834 17.6091C16.5826 19.0483 16.5001 20.1666 13.9426 20.1666H8.05761C5.50011 20.1666 5.41761 19.0483 5.31678 17.6091L4.72095 8.3783",
    stroke: "#FF2929",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46924 15.125H12.5217",
    stroke: "#FF2929",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70825 11.4584H13.2916",
    stroke: "#FF2929",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.f0d8dbdbfaf7fa9decf9a60100e47e7d.svg";
export { ForwardRef as ReactComponent };